import { z } from 'zod';

export const NewEntityCountryIdSchema = () => {
	return z.object({
		newEntityCountryId: z.string().trim().optional()
	});
};

export type NewEntityCountryIdValuesIn = z.input<
	ReturnType<typeof NewEntityCountryIdSchema>
>;
export type NewEntityCountryIdValuesOut = z.output<
	ReturnType<typeof NewEntityCountryIdSchema>
>;
